<template>
  <div id="group_member_outer" v-if="memeberList != null">
    <div>
      <div id="group_member_filters_out">
        <div v-for="(item, index) in filterList"
             :key="'group_filters_index_' + index">
          <a href="javascript:void(0);"
            :class="[filterTab == index ? 'active' : '']"
             @click="filterMenuClicked(index)"
          >{{item.typeName + '(' + item.num + ')'}}</a>
        </div>
      </div>
      <div style="min-height: 400px;">
        <table class="table table-striped" id="group_member_table" v-if="memeberList.length > 0">
          <thead>
          <tr>
            <th
              style="text-align: center;"
              v-for="(item, index) in memberHeadList"
              v-if="!(hideForSmallScreen && (index == 3 || index == 5))"
              :key="'member_item_' + index"
            >{{item}}</th>
          </tr>
          </thead>
          <tbody>
          <tr style="text-align: center;" v-for="(item, index) in memeberList" :key="'group_member_' + index">
            <td><a :href="memberSrc(item)" target="_blank">{{(item.name == null || item.name.length == 0) ? item.nickname : item.name}}</a></td>


<!--            <td>{{(item.name == null || item.name.length == 0) ? item.nickname : item.name}}</td>-->
            <td><a :href="memberSrc(item)" target="_blank">{{(item.typeName == null || item.typeName == '') ? '暂无' : item.typeName}}</a></td>
            <td><a :href="memberSrc(item)" target="_blank">{{item.sex == 0 ? '保密' : (item.sex == 1 ? '男' : '女')}}</a></td>
            <td v-if="!hideForSmallScreen"><a :href="memberSrc(item)" target="_blank">{{(itemDateText(item.birthday))}}</a></td>
            <td><a :href="memberSrc(item)" target="_blank">{{item.area}}</a></td>
            <td v-if="!hideForSmallScreen"><a :href="memberSrc(item)" target="_blank">{{itemDateText(item.joinTime)}}</a></td>
            <td><a href="javascript:void(null);" class="group_member_remove" @click="removeMember(item)">移除</a></td>
          </tr>
          </tbody>

        </table>
        <div v-else style="font-size: 1.5rem;color: #666;text-align: center;padding-top: 150px;">暂无成员</div>
      </div>
      <div style="width: 100%;padding-left: 15px;padding-right: 15px;">
        <bottom-paginator
          v-bind:current="page"
          v-bind:total="totalPage"
          v-on:itemClicked="paginatorClicked"
          :paginatorType="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BottomPaginator from "../BottomPaginator";
export default {
  name: "GroupMember",
  components: {
    BottomPaginator
  },
  data() {
    return {
      title: '旗下成员',

      filterList: [
        {
          typeName: '全部',
          num: 0,
        },
      ],
      filterTab: 0,
      memeberList: null,
      memberHeadList: [
        '成名名称',
        '成员类别',
        '性别',
        '出生日期',
        '所在地区',
        '加入时间',
        '管理'
      ],
      page: 1,
      size: 10,
      count: 0,
      hideForSmallScreen: false,
      isMemberDataLoading: false,
    }
  },
  computed: {
    user(){
      return this.$store.state.user;
    },
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    }
  },
  mounted() {
    this.loadMemberStatData();
    this.loadData();
    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 500);
  },
  methods: {


    memberSrc(item) {
      return '/introduce/0203/detail/' + item.id;
    },

    updateStatus() {
      let tableWitdh = $('#group_member_table').width();
      console.log('table-width: ' + tableWitdh);
      if (tableWitdh >= 600) {
        this.hideForSmallScreen = false
      } else  {
        this.hideForSmallScreen = true
      }
    },

    filterMenuClicked(index) {
      this.filterTab = index;
      this.pageIndex = 1;
      this.loadData();
    },

    itemDateText(date) {
      let currentDate = this.$moment(date);
      if (currentDate.isValid()) {
        return  currentDate.format('yyyy-MM-DD');
      }
      return '暂无';
    },

    memberType(type) {
      if (type == null) {
        return '暂无';
      }
      switch (type) {
        case 1:
          return '教练员';
        case 2:
          return '裁判员';
        case 3:
          return '体育从业人员';
        case 4:
          return '普通成员';
        default:
          return '类型错误';
      }
    },
    paginatorClicked(event) {
      let index = event.index;
      this.paginatorItem.current = index;
      this.loadData();
    },

    loadData() {
      if (this.filterTab == 0) {
        this.loadTotalMemberData();
      } else {
        this.loadMembersCateData();
      }
    },

    loadTotalMemberData() {
      if (this.isMemberDataLoading) {
        return;
      }
      let pageIndex = this.page;
      let params = {
        pageIndex,
        size: this.size
      };
      let _this = this;
      this.isMemberDataLoading = true;
      this.$store.state.http.ajax.ucMembers(params, function (data) {
        _this.isMemberDataLoading = false;
          console.log(data);
          let code = data.code;
          if (code == 0) {

            _this.filterList[0].num = data.count;
            _this.count = data.count;

            let list = data.data;
            console.log(list);
            console.log('member-list' + list);
            if (list != null) {
              if (pageIndex > 1) {
                _this.memeberList = _this.memeberList.concat(list);
              } else {
                _this.memeberList = list;
              }
              return;
            }
          }
          if (pageIndex > 1) {
            pageIndex --;
            _this.pageIndex = pageIndex;
          }
      }, function (data) {
        _this.isMemberDataLoading = false;
        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
        }
          _this.$toast('请求失败，请重试！');
      })
    },
    removeMember(item) {
      // console.log(userId);
      console.log('---1');
      console.log(item);
      // 移除成员
      let userId = item.id;
      let teamId = this.user.id;
      let params = {
        teamId,
        userId
      };
      console.log(params);
      let _this = this;
      this.$store.state.http.ajax.ucTeamsQuit(params, function (data) {
        console.log(data);
        if (data.code == 0) {
          _this.$toast('移除成功！');
          _this.removeUserItem(userId);
          return;
        }
        _this.$toast('移除失败！');
      }, function (data) {
        _this.$toast('请求失败，请重试！');
      })
    },
    removeUserItem(userId) {
      let itemList = this.memeberList;
      let newList = [];
      for (let i = 0; i < itemList.length; i++) {
        let item = itemList[i];
        if (item.id != userId) {
          newList.push(item);
        }
      }

      this.memeberList = newList;
    },


    loadMembersCateData() {
      if (this.isMemberDataLoading) {
        return;
      }
      let pageIndex = this.page;
      let cate = this.filterList[this.filterTab].typeName;
      let params = {
        pageIndex,
        size: this.size,
        cate,
      };
      let _this = this;
      this.isMemberDataLoading = true;
      this.$store.state.http.ajax.ucMembersCate(params, function (data) {
        _this.isMemberDataLoading = false;
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.count = data.count;
          let list = data.data;
          if (list != null && list.length > 0) {
            if (pageIndex > 1) {
              _this.memeberList = _this.memeberList.concat(list);
            } else {
              _this.memeberList = list;
            }
            return;
          }
        }
        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
        }

      },function (data) {
        _this.isMemberDataLoading = false;
        if (pageIndex > 1) {
          pageIndex --;
          _this.pageIndex = pageIndex;
        }
        _this.$toast('请求失败，请重试！');
      })
    },
    loadMemberStatData() {
      let _this = this;
      this.$store.state.http.ajax.ucMemberStat(function (data) {
        console.log('stat data');
        console.log(data);
        let code = data.code;
        if (code == 0) {
          let tagsList = data.data;

          if (tagsList != null && tagsList.length > 0) {
            _this.filterList = _this.filterList.concat(tagsList);
          }
        }
      }, function (data) {

      });

    }

  }
}
</script>

<style scoped>

  #group_member_outer {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: center;
    align-self: center;
    padding-top: 30px;
    padding-bottom: 40px;

  }

  #group_member_outer > div {
    min-width: 300px;
    /*max-width: 1000px;*/
    /*min-height: 500px;*/
    width: 100%;
    border: solid 1px #cbb042;
    padding-bottom: 30px;
  }

  #group_member_filters_out {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    flex-direction: row;flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    border-bottom: solid 1px #cbb042;
  }


  @media screen and (min-width: 800px) {
    #group_member_filters_out {
      justify-content: space-around;
    }
  }

  #group_member_filters_out div {
    padding: 10px 15px;
    font-size: 1.5rem;
    color: #333;
  }

  #group_member_filters_out a {
    text-decoration: none;
    color: inherit;
    font-size: inherit;
    min-width: 100px;
    display: inline-block;
    text-align: center;
  }

  #group_member_filters_out a.active {
    color: #cbb042;
    pointer-events: none;
  }

  #group_member_filters_out a:hover {
    color: #cbb042;
  }


  #group_member_table > thead th {
    /*text-align: center;*/
    font-size: 1rem;
    font-weight: bold;
  }

  #group_member_table td {
    text-align: center;
    font-size: 1rem;
  }

  #group_member_table a {
    color: inherit;
    text-decoration: none;
  }

  #group_member_table a:hover {
    color: #fc1a34;
  }

  .group_member_remove {
    color: #ca4f5d;
    font-size: 1rem;
    text-decoration: none;
  }

  .group_member_remove:hover {
    color: #aa4f5d;
  }

  .hidenAtSmallScreen {
    display: none;

  }


  @media screen and (min-width: 768px) {
    .hidenAtSmallScreen {
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/group/GroupMember.vue